import React from 'react';
import styles from './ResetPasswordNotification.module.css';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const ResetPasswordNotification = () => {
    const navigate = useNavigate();

    return (
        <>
            <div>
                <div className={styles.loginWrapper}>
                    <h2 className={styles.loginTitle}>Reset Password</h2>

                    <p className={styles.loginInfo}>
                        We’ve shared a link to reset your account password on email <span>alma.lawson@example.com</span> . Didn’t received?{' '}
                        <Link to="">Resend</Link>{' '}
                    </p>
                    <p className={styles.backBtn} onClick={() => navigate(-1)}>
                        Back
                    </p>
                </div>
            </div>
        </>
    );
};

export default ResetPasswordNotification;
